import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const OurMission = () => {
    const fadeIn = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
    };

    return (
        <div className="our-mission-page">
            <motion.section 
                className="our-mission-hero"
                initial="hidden"
                animate="visible"
                variants={fadeIn}
            >
                <h1 className="our-mission-title">Our Mission</h1>
                <p className="our-mission-tagline">
                    Empowering students to achieve their full academic potential
                </p>
            </motion.section>

            <section className="our-mission-content">
                <motion.div 
                    className="mission-section"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeIn}
                >
                    <div className="mission-icon">🎯</div>
                    <h2>Our Purpose</h2>
                    <p>
                        Our mission is to empower students to achieve their full academic potential. We believe that every student has the ability to succeed, and we are committed to providing the support and guidance they need to reach their goals.
                    </p>
                </motion.div>

                <motion.div 
                    className="mission-section"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeIn}
                >
                    <div className="mission-icon">👥</div>
                    <h2>Our Team</h2>
                    <p>
                        We are a team of passionate and experienced educators who are dedicated to helping students develop the skills and confidence they need to succeed in school and beyond. We offer a variety of services to meet the unique needs of each student, including one-on-one tutoring, small group instruction, and test preparation.
                    </p>
                </motion.div>

                <motion.div 
                    className="mission-section"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeIn}
                >
                    <div className="mission-icon">🏆</div>
                    <h2>Our Impact</h2>
                    <p>
                        We are proud to have helped thousands of students achieve their academic goals, and we look forward to helping you achieve yours.
                    </p>
                </motion.div>
            </section>

            <motion.section 
                className="our-mission-cta"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeIn}
            >
                <h2>Ready to Start Your Journey?</h2>
                <p>Join thousands of students who have achieved their academic goals with Synapse</p>
                <Link to="/" className="button-primary">
                    Explore Our Services
                </Link>
            </motion.section>
        </div>
    );
};

export default OurMission;
